export const routes = (prefix, pre) => [
    {
        name: `${prefix}.${pre}.admission-report.index`,
        path: `/${prefix}/${pre}/admission-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.admission-report.index`,
                PageDescription: "Patient Reports: Admissions report",
            },
        },
    },{
        name: `${prefix}.${pre}.patient-admission-report.index`,
        path: `/${prefix}/${pre}/patient-admission-report`,
        component: () => import('./Index-Other.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.patient-admission-report.index`,
                PageDescription: "Patient Reports: Other Admissions report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.print.admission-report.index`,
        path: `/${prefix}/${pre}/admission-report/print`,
        component: () => import('./prints/VisitReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.admission-report.index`,
                PageDescription: "Patient Reports: Admissions report",
            },
            print: true,
        },
    },{
        name: `${prefix}.${pre}.print.patients-admission-report.index`,
        path: `/${prefix}/${pre}/patients-admission-report/print`,
        component: () => import('./prints/PrintAdmissionReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.patients-admission-report.index`,
                PageDescription: "Patient Reports: Patients Admissions report",
            },
            print: true,
        },
    },
];